import React from "react";
import { CoachRecording } from "../../types/coach-recording.entity";

const statusMap: Record<CoachRecording["manualReviewStatus"], string> = {
  UNDER_REVIEW: "bg-yellow-100 text-yellow-800",
  APPROVED: "bg-green-100 text-green-800",
  REJECTED: "bg-red-100 text-red-800",
  PENDING: "bg-blue-100 text-blue-800",
  USER_CANCELED: "bg-orange-100 text-orange-800",
};

type StatusBadgeProps = {
  status: CoachRecording["manualReviewStatus"];
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => (
  <span className={`px-3 py-1 rounded-full text-sm ${statusMap[status] ?? "bg-gray-100 text-gray-800"}`}>
    {status.replace(/_/g, " ").toLowerCase()}
  </span>
);
